import { styled, ToggleButtonGroup } from "@mui/material";

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(
  ({ margin, fontSize, height, padding }) => ({
    gap: "1.1rem",
    margin: margin,
    marginTop: "2px",
    flexWrap: "wrap",
    "& .MuiTab-root": {
      minHeight: "auto !important",
      padding: "5px 1.5rem",
      fontWeight: 700,
      minWidth: "auto",
    },
    //   "& .MuiToggleButtonGroup-root": {
    //     padding: "3px 3px 3px 0px",
    //     gap: "1rem !important",
    //   },
    "& .MuiToggleButton-root": {
      border: "1px solid #D0D5DD !important",
      padding: padding || "7px 1rem",
      borderRadius: "8px",
      color: "#344054",
      fontWeight: 600,
      fontSize: fontSize,
      height: height,
    },
    "& .Mui-selected": {
      background: "#543A8A !important",
      margin: "0px",
      padding: padding || "7px 1rem",
      color: "#fff !important",
      borderRadius: "8px",
      height: height,
    },
  })
);
